module.exports = __webpack_public_path__ + "static/media/Avatars_Other-18.264260f3.png";